import { useSelector } from 'react-redux';

import { selectExperiments } from '../../selectors/experiments';
import { isDailyrentDesktopHybridExpActive } from '../../utils/experiments';

export function useIsDailyrentDesktopHybridExpActive(): boolean {
  const experiments = useSelector(selectExperiments);

  return isDailyrentDesktopHybridExpActive(experiments);
}
